<template>
  <div class="base">
    <div class="top-head">
      <inside-header title="课程详情" color="white" />
      <div class="main">
        <div class="course-details">
          <div class="title">
            {{ service_pack.title }}
          </div>
          <div class="desc">
            {{ service_pack.desc }}
          </div>
          <div v-if="login_account === 'teacher'" style="margin-top: 20px;">
            教员您好，需要以家长身份登录才可购买
          </div>
          <div v-if="login_account === ''" style="margin-top: 20px;">
            <a-button type="primary" size="large" block @click="goUserLogin">
              家长登录
            </a-button>
          </div>
          <div v-if="login_account === 'user'" class="create-order">
            <van-form input-align="right" @submit="onSubmit">
              <div v-if="!loading && students.length === 0">
                <van-field label="选择学员" required>
                  <template #input>
                    <a-button @click="goAddStudent">
                      添加学员
                    </a-button>
                  </template>
                </van-field>
              </div>
              <div v-else>
                <van-field required clickable name="student_name" label="选择学员" :value="studentName"
                  :rules="[{ required: true, message: '请选择学员' }]" @click="state.selectStudents = true" />
                <van-popup v-model="state.selectStudents" position="bottom">
                  <van-picker show-toolbar :columns="studentsCloumn" @confirm="onStudentsConfirm"
                    @cancel="state.selectStudents = false" />
                </van-popup>
              </div>
              <van-field required clickable name="teaching_subject" label="选择授课" :value="teach"
                :rules="[{ required: true, message: '请选择授课科目' }]" @click="state.selectTeach = true" />
              <van-popup v-model="state.selectTeach" position="bottom">
                <van-picker show-toolbar :columns="teachCloumn" @confirm="onTeachConfirm"
                  @cancel="state.selectTeach = false" />
              </van-popup>
              <van-field name="cycle" :label="'周期(' + cycle + ')'" required>
                <template #input>
                  <van-slider v-model="cycle" :min="min_cycle" :max="max_cycle" @change="onCycleChange" />
                </template>
              </van-field>
              <div class="teaching-day">
                <a-row>
                  <a-col class="label-title" :span="7">
                    <span class="teaching-day-label">授课日</span>
                  </a-col>
                  <a-col class="contents" :span="16">
                    <van-badge class="prop-btn-area" :content="teachingData.saturday">
                      <a-button :disabled="saturday" class="prop-btn" @click="selectDate('saturday')">
                        周六
                      </a-button>
                    </van-badge>
                    <van-badge class="prop-btn-area" :content="teachingData.sunday">
                      <a-button :disabled="sunday" class="prop-btn" @click="selectDate('sunday')">
                        周日
                      </a-button>
                    </van-badge>
                    <van-badge class="prop-btn-area" :content="teachingData.monday">
                      <a-button :disabled="monday" class="prop-btn" @click="selectDate('monday')">
                        周一
                      </a-button>
                    </van-badge>
                    <van-badge class="prop-btn-area" :content="teachingData.tuesday">
                      <a-button :disabled="tuesday" class="prop-btn" @click="selectDate('tuesday')">
                        周二
                      </a-button>
                    </van-badge>
                    <van-badge class="prop-btn-area" :content="teachingData.wednesday">
                      <a-button :disabled="wednesday" class="prop-btn" @click="selectDate('wednesday')">
                        周三
                      </a-button>
                    </van-badge>
                    <van-badge class="prop-btn-area" :content="teachingData.thursday">
                      <a-button :disabled="thursday" class="prop-btn" @click="selectDate('thursday')">
                        周四
                      </a-button>
                    </van-badge>
                    <van-badge class="prop-btn-area" :content="teachingData.friday">
                      <a-button :disabled="friday" class="prop-btn" @click="selectDate('friday')">
                        周五
                      </a-button>
                    </van-badge>
                  </a-col>
                </a-row>
                <van-action-sheet v-model="state.showDuration" title="标题" @cancel="cancelDuration">
                  <div class="content" style="padding: 16px;">
                    <van-field :label="'授课时长(' + durationValue + ')'" show-toolbar>
                      <template #input>
                        <van-slider v-model="durationValue" name="now_duration" :min="durationMin" :max="durationMax"
                          @change="durationChange" />
                      </template>
                      <template #button>
                        <a-button size="small" type="primary" @click="determineTeaching">
                          确定
                        </a-button>
                      </template>
                    </van-field>
                  </div>
                </van-action-sheet>
              </div>
              <!-- 备注 -->
              <van-field v-model="notes" name="notes" rows="2" autosize label="留言" type="textarea" maxlength="100"
                placeholder="请输入留言" show-word-limit />
              <div class="total">
                <span class="prefix">￥</span>
                <span class="money">{{ weekHours * price * cycle }}</span>
              </div>
              <div style="margin: 16px;" class="btn-area">
                <a-button block type="primary" html-type="submit" :disabled="submitDisabled" :loading="state.submit">
                  购买
                </a-button>
              </div>
            </van-form>
          </div>
        </div>
      </div>
      <!-- info：教员的基本信息 -->
      <div class="other-area">
        <div class="teacher-info">
          <div class="info">
            <span class="name">{{ teacher_info.nick_name }}</span>
            <span class="number" style="margin-left: 5px;">T{{ teacher_info.id }}</span>
            <span class="score">
              <a-rate :default-value="5" disabled style="color: #ff5c00;" />
            </span>
          </div>
          <div class="description">
            {{ teacher_info.self_evaluation }}
          </div>
          <!-- 视频简介 -->
          <div style="margin-top: 10px;">
            <div class="title-label" style="">
              视频介绍
            </div>
          </div>
          <div v-if="!showTeacherVideo" class="introduce-video" @click="onShowTeacherVideoHandle">
            <span>教师风采</span>
            <span>教师风采</span>
            <div class="play-button" />
            <div class="play-button-area" />
            <a-icon class="paly-icon" type="caret-right" />
            <video src="" width="346px" height="203px" />
          </div>
          <div v-if="showTeacherVideo" class="introduce-video-show">
            <video controls="controls">
              <source :src="teacherVideoUrl" type="video/mp4">
              <object :data="teacherVideoUrl" width="346px" height="203px">
                <embed :src="teacherVideoUrl" width="346px" height="203px">
              </object>
            </video>
          </div>
        </div>
        <div style="margin-top: 10px;">
          <div class="title-label" style="">
            授课区域
          </div>
        </div>
        <!-- 地图 -->
        <div class="map">
          <custom-map v-if="city && !loading" map-height="200px" :map-edit="mapEdit" :city="city" :address="address"
            :polygon="map_polygon" :circle="map_circle" @overwriteData="mapDataHandle" />
        </div>
        <!-- 其他服务包 -->
        <div class="other-pack">
          <div class="orange-color-block" />
          <div class="top-area clear">
            <span class="label-left pull-left">
              其他服务包（{{ other_pack.length }}）
            </span>
            <span class="pull-right">
              <a href="">查看更多</a>
            </span>
          </div>
          <div v-if="other_pack.length > 0" class="list">
            <div v-for="(pack, index) in other_pack" :key="index" class="item">
              <div class="title" @click="purchasingServices(pack.id)">
                {{ pack.title }}
              </div>
              <div class="description">
                {{ pack.desc }}
              </div>
              <div class="course">
                {{ pack.teaching_subjects }}
              </div>
            </div>
          </div>
          <van-empty v-else description="暂无数据" />
        </div>
        <!-- 评价  -->
        <div class="evaluation-area">
          <div class="title">
            评价（{{ commit_list.length }}）
          </div>
          <div v-if="commit_list.length > 0" class="list">
            <div v-for="(commit, index) in commit_list" :key="index" class="item">
              <a-row>
                <a-col class="info" :span="5">
                  <div class="img">
                    <img src="@/assets/test-header.png" alt="">
                  </div>
                  <div class="name">
                    {{ commit.nick_name }}
                  </div>
                </a-col>
                <a-col class="content" :span="19">
                  <div class="score">
                    <a-rate :default-value="commit.star" disabled style="color: #ff5c00;font-size: 10px;" />
                  </div>
                  <div class="comment">
                    {{ commit.commit }}
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
          <van-empty v-else description="暂无数据" />
        </div>
      </div>
    </div>
    <main-footer />
  </div>
  <!-- 教员介绍 -->
</template>
<script>
import { InsideHeader, MainFooter, CustomMap } from '@/components'
import store from '@/store/'

export default {
  name: 'TutorInfo',
  components: {
    InsideHeader,
    MainFooter,
    CustomMap
  },
  props: {
    id: {}
  },
  data() {
    return {
      loading: true,
      login_account: '',
      state: {
        selectStudents: false,
        selectTeach: false,
        showDuration: false,
        submit: false
      },
      submitDisabled: true,
      studentsCloumn: [],
      studentName: '',
      student_id: '',
      teach: '',
      cycle: 2,
      selectDay: '',
      durationValue: 0,
      durationMin: 2,
      durationMax: 6,
      teachingData: {
        saturday: 0,
        sunday: 0,
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0
      },
      notes: '',
      // 价格
      price: '',
      weekHours: 0,
      weekHourStr: '',
      // 显示教员视频
      showTeacherVideo: false,
      teacherVideoUrl: '',
      // 地图
      mapEdit: false,
      city: '广安市',
      address: '',
      map_circle: [],
      map_polygon: [],
      // 逻辑数据
      min_cycle: 1,
      max_cycle: 10,
      week_day: [],
      week_name: '',
      teachCloumn: [],
      // 数据
      userInfo: {},
      // 一周允许时间
      allow_week_day: [],
      allow_user_hour: {},
      // 授课日是否禁用数据
      saturday: true,
      sunday: true,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      service_pack: {},
      teaching_subjects_arr: [],
      teacher_info: {},
      students: [],
      // 评论
      commit_list: [],
      // 其他包
      other_pack: []
    }
  },
  computed: {},
  watch: {
    // url改变，重新加载数据
    $route() {
      this.loadData(this.id)
    },
    service_pack(newData) {
      this.min_cycle = newData.min_cycle
      this.max_cycle = newData.max_cycle
      this.price = newData.price
      if (newData.teaching_subjects) {
        this.teachCloumn = newData.teaching_subjects.split(',')
      }
    },
    allow_week_day(newData) {
      for (var i = 0; i < newData.length; i++) {
        if (newData[i] === 'saturday') {
          this.saturday = false
        }
        if (newData[i] === 'sunday') {
          this.sunday = false
        }
        if (newData[i] === 'monday') {
          this.monday = false
        }
        if (newData[i] === 'tuesday') {
          this.tuesday = false
        }
        if (newData[i] === 'wednesday') {
          this.wednesday = false
        }
        if (newData[i] === 'thursday') {
          this.thursday = false
        }
        if (newData[i] === 'friday') {
          this.friday = false
        }
      }
    },
    teacher_info(newData) {
      this.address = newData.address
      if (newData.province) {
        var str = '北京市,天津市,上海市,重庆市'
        if (str.search(newData.province) > -1) {
          this.city = newData.province
        } else {
          this.city = newData.city
        }
      }
      if (newData.teaching_video_info.url !== undefined) {
        this.teacherVideoUrl = newData.teaching_video_info.url
      }

      // 地图上授课区域
      if (newData.teaching_area_map) {
        this.teachingAreaMap = newData.teaching_area_map
        // 后台解析好的
        var teachingAreaMapInfo = newData.teaching_area_map_info
        this.map_circle = teachingAreaMapInfo.circle
        this.map_polygon = teachingAreaMapInfo.polygon
      }
    },
    students(value) {
      var data = []
      if (value.length > 0) {
        this.submitDisabled = false
      }
      value.forEach(item => {
        data.push({
          text: item.nick_name,
          id: item.id
        })
      })
      this.studentsCloumn = data
    },
    teachingData: {
      handler(val) {
        var weekHourStr = ''
        var weekHours = 0
        if (val) {
          for (var prop in val) {
            weekHours += val[prop]
            if (weekHourStr === '') {
              weekHourStr = val[prop]
            } else {
              weekHourStr = weekHourStr + ' + ' + val[prop]
            }
          }
        }
        this.weekHours = weekHours
        this.weekHourStr = weekHourStr
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.id === '') {
      this.$router.go(-1)
    }
    this.userInfo = store.getters.userInfo
    this.loadData(this.id)
  },
  methods: {
    loadData(id) {
      this.loading = true
      this.$http({
        url: '/index/index/purchase',
        method: 'get',
        params: {
          id: id
        }
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          const data = res.data
          console.log(data)
          this.login_account = data.login_account
          this.teacher_info = data.teacher_info
          this.service_pack = data.service_pack
          this.students = data.students
          this.other_pack = data.other_pack
          this.commit_list = data.commit_list
          this.allow_user_hour = data.allow_user_hour
          this.allow_week_day = data.allow_week_day
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    onSubmit(values) {
      var tempData = {}
      // 只上传有数据的数据
      if (this.teachingData.friday >= 2) {
        tempData.friday = this.teachingData.friday
      }
      if (this.teachingData.monday >= 2) {
        tempData.monday = this.teachingData.monday
      }
      if (this.teachingData.saturday >= 2) {
        tempData.saturday = this.teachingData.saturday
      }
      if (this.teachingData.sunday >= 2) {
        tempData.sunday = this.teachingData.sunday
      }
      if (this.teachingData.thursday >= 2) {
        tempData.thursday = this.teachingData.thursday
      }
      if (this.teachingData.tuesday >= 2) {
        tempData.tuesday = this.teachingData.tuesday
      }
      if (this.teachingData.wednesday >= 2) {
        tempData.wednesday = this.teachingData.wednesday
      }
      values.teaching_data = tempData
      // 新增
      values.pack_id = this.id
      values.student_id = this.student_id
      console.log(values)
      this.state.submit = true
      this.$http({
        url: '/index/order/create',
        method: 'post',
        data: values
      }).then(res => {
        this.state.submit = false
        if (res.status === 'success') {
          this.$notification.success({
            message: '成功',
            description: '创建订单成功'
          })
          // 跳转支付页
          this.$router.push({
            name: 'TutorPay',
            params: { id: res.data.ordernum }
          })
        } else {
          this.$notification.error({
            message: '失败',
            description: res.message
          })
        }
      })
    },
    onCycleChange(value) {
      this.$toast('当前值：' + value)
    },
    onStudentsConfirm(value) {
      this.studentName = value.text
      this.student_id = value.id
      this.state.selectStudents = false
    },
    onTeachConfirm(value) {
      this.teach = value
      this.state.selectTeach = false
    },
    selectDate(week) {
      this.state.showDuration = true
      // 当前操作的周末
      this.selectDay = week
      this.durationMin = 2
      // 根据当前的选择控制拉条的数据
      if (week === 'saturday') {
        this.durationMax = this.allow_user_hour.saturday
      } else if (week === 'sunday') {
        this.durationMax = this.allow_user_hour.sunday
      } else if (week === 'monday') {
        this.durationMax = this.allow_user_hour.monday
      } else if (week === 'tuesday') {
        this.durationMax = this.allow_user_hour.tuesday
      } else if (week === 'wednesday') {
        this.durationMax = this.allow_user_hour.wednesday
      } else if (week === 'thursday') {
        this.durationMax = this.allow_user_hour.thursday
      } else if (week === 'friday') {
        this.durationMax = this.allow_user_hour.friday
      }
      // 根据后台传递处理初始值
      // durationMin: 2,
      // durationMax: 6,
    },
    cancelDuration() {
      this.state.showDuration = false
      this.$set(this.teachingData, this.selectDay, 0)
    },
    // 课程时间选择修改
    durationChange(value) {
      this.$set(this.teachingData, this.selectDay, value)
      console.log(this.teachingData)
      this.$toast('当前值：' + value)
    },
    goUserLogin() {
      this.$router.push({ name: 'UserLogin' })
    },
    // 确定授课时长
    determineTeaching() {
      // 关闭即可
      this.state.showDuration = false
    },
    onShowTeacherVideoHandle() {
      this.showTeacherVideo = true
    },
    // 地图数据，存储到数据库中。前台使用
    mapDataHandle() { },
    purchasingServices(packageId) {
      this.$router.push({ name: 'TutorInfo', params: { id: packageId } })
    },
    goAddStudent() {
      this.$router.push({ name: 'UserStudentEdit' })
    }
  }
}
</script>
<style lang="stylus" scoped>
.base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
}

.main {
  padding: 0 15px;
  margin-top: 25px;
}

.top-head {
  width: 100%;
  background: url('~@/assets/order/back@2x.png') no-repeat;
  // 背景图片自适应div
  background-size: contain;
  overflow: hidden;

  .course-details {
    // height: 260px;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 30px 15px;
    box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

    .title {
      font-family: PingFang-SC-Bold;
      font-size: 16px;
      line-height: 16px;
      color: #333333;
      font-weight: bold;
    }

    .desc {
      font-family: PingFang-SC-Medium;
      font-size: 14px;
      line-height: 16px;
      color: #666666;
      margin-top: 10px;
    }

    .create-order {
      margin-top: 25px;

      .teaching-day {
        padding: 10px 16px;

        .label-title {
          line-height: 40px;
        }

        .contents {

          .prop-btn-area {
            margin: 4px;

            .prop-btn {
              padding: 2px 4px;
              background-color: #f5f5f5;
              border-radius: 10px;
              font-size: 12px;
            }
          }
        }
      }

      .btn-area {

        button {
          height: 40px;
          background-color: #ff5c00;
          border-radius: 10px;
        }
      }
    }
  }
}

.total {
  weight: 100%;
  text-align: right;
  margin-top: 20px;

  .prefix {
    font-family: PingFang-SC-Bold;
    font-size: 12px;
    line-height: 12px;
    color: #ff5c00;
  }

  .money {
    font-family: PingFang-SC-Bold;
    font-size: 18px;
    font-weight: normal;
    color: #ff5c00;
  }
}

.teaching-day-label::before {
  position: absolute;
  left: -8px;
  color: #ee0a24;
  font-size: 14px;
  content: '*';
}

.other-area {
  margin-top: 40px;
  padding: 0 15px;
  background-color: #fff;
}

.teacher-info {

  .info {
    overflow: hidden;
    height: 32px;

    .name {
      height: 16px;
      font-family: PingFang-SC-Bold;
      font-size: 16px;
      line-height: 32px;
      color: #333333;
      float: left;
    }

    .number {
      font-family: PingFang-SC-Bold;
      font-size: 16px;
      color: #ff5c00;
      float: left;
      line-height: 32px;
    }

    .score {
      float: right;
    }
  }

  .description {
    font-family: PingFang-SC-Regular;
    font-size: 14px;
    line-height: 18px;
    color: #333333;
    margin-top: 15px;
  }

  .introduce-video {
    // text-align: center;
    margin-top: 15px;
    position relative
    cursor pointer

    span {
      height: 28px;
      font-family: BDZYJT--GB1-0;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 25px;
      letter-spacing: 0px;
      color: #eee;
    }

    span:first-child {
      position: absolute;
      top: 90px;
      left: 20px;
    }

    span:nth-child(2) {
      position: absolute;
      top: 90px;
      left: 210px;
    }

    .play-button {
      width: 36px;
      height: 36px;
      background-color: #ffffff;
      opacity: 0.2;
      border-radius: 50%;

      position: absolute;
      top: 87px;
      left: 155px;
    }

    .play-button-area {
      width: 24px;
      height: 24px;
      background-color: #ffffff;
      opacity: 0.5;
      border-radius: 50%;

      position: absolute;
      top: 93px;
      left: 161px;
    }

    .paly-icon {
      font-size: 22px;
      color: #fff;

      position: absolute;
      top: 94px;
      left: 163px;
    }

    video {
      background-image: linear-gradient(0deg, #ff5c00 0%, #ff9000 100%),
      linear-gradient(#ff5c00, #ff5c00);
      background-blend-mode: normal, normal;
      border-radius: 10px;
    }
  }

  .introduce-video-show {
    width: 346px;
    height: 203px;
    border-radius: 10px;
    margin-top: 15px;

    video {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }
}

// 地图
.map {
  margin-top: 15px;
}

// 服务包列表
.other-pack {
  margin-top: 15px;
  box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
  padding: 13px 15px 15px 15px;
  overflow: hidden;

  .orange-color-block {
    width: 111px;
    height: 9px;
    background-color: #fa750d;
    border-radius: 4px;
    position: relative;
    top: -16px;
  }

  .top-area {
    height: 22px;

    .label-left {
      font-family: PingFang-SC-Medium;
      font-size: 16px;
      line-height: 16px;
      color: #333333;
    }

    .pull-right {
      font-family: PingFang-SC-Medium;
      font-size: 12px;
      line-height: 16px;
      color: #666666;
    }
  }

  .list {
    margin-top: 20px;

    .item {
      background-color: #f6f6f6;
      border-radius: 10px;
      margin-bottom: 15px;
      padding: 15px;

      .title {
        font-family: PingFang-SC-Medium;
        font-size: 16px;
        line-height: 16px;
        color: #333333;
      }

      .description {
        font-family: PingFang-SC-Regular;
        font-size: 14px;
        line-height: 16px;
        color: #666666;
        margin-top: 14px;
      }

      .course {
        font-family: PingFang-SC-Medium;
        font-size: 12px;
        line-height: 16px;
        color: #333333;
        margin-top: 20px;
      }
    }
  }
}

// 评论区
.evaluation-area {
  margin-top: 30px;

  .title {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    line-height: 16px;
    color: #333333;
  }

  .list {
    margin-top: 9px;

    .item {
      padding: 10px 0px;
      border-bottom: 1px solid #f6f6f6;

      .info {
        text-align: center;
        .img {
          img {
            weight: 60px;
            height: 60px;
          }
        }

        .name {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 16px;
          color: #333333;
        }
      }

      .content  {
        .score {
        }

        .comment {
          font-family: PingFang-SC-Regular;
          font-size: 12px;
          line-height: 16px;
          color: #666666;
          margin-top: 8px;
        }
      }
    }
  }
}

// 重置拉条的颜色
.van-slider__bar {
    background-color: $theme-color;
}
</style>
